//PRVX change here — brand asset: public/images/Prvx.png
import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const ProveXIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/Prvx.png" style={style} />
}
